import React from 'react';
import { Alert, Col, Row } from 'components';

const STATUES_MAPPING: Record<string, any> = {
  SOURCED: 'Sourced',
  PRICE_CONFIRMED: 'Price Confirmed',
};

export const FinalStatusBanner = React.memo((props: { status?: string }) => {
  const { status = 'SOURCED' } = props;

  return (
    <Row>
      <Col span={24}>
        <Alert
          style={{ width: '100%' }}
          message={`The purchase request is now in '${STATUES_MAPPING[status as string]}' status and cannot be modified further.`}
          type="info"
          showIcon
        />
      </Col>
    </Row>
  );
});
